import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Staff } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class StaffModule extends VuexModule {
    @Action
    [Staff.getStaffList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/staff/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Staff.findPageStaff](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/staff`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Staff.saveStaff](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/staff/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Staff.deleteStaff](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/staff/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}